import {Button, Form, Spin} from 'antd';
import styles from '../index.module.scss';
import {useForm} from 'antd/es/form/Form';
import useRequest from 'Utils/Hooks/useRequest';
import {NormalLoginSettingForm} from '../service';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {Auth} from '../../../../Features/Auth';
import {SimpleSwitch} from 'Features/Fields/SimpleSwitch';

export function SsoLogin() {
    const [form] = useForm<NormalLoginSettingForm>();

    const [, {loading}] = useRequest(async () => {});

    const [onSave, saveStatus] = useRequestFn(
        async (data: NormalLoginSettingForm) => {},
    );

    return (
        <div className={styles.root}>
            <Spin spinning={loading}>
                <Form
                    form={form}
                    labelCol={{span: 4, style: {paddingRight: 20}}}
                    wrapperCol={{span: 8}}
                    onFinish={onSave}>
                    <Form.Item label="统一身份认证登录" name="status">
                        <SimpleSwitch />
                    </Form.Item>

                    <Form.Item label=" " colon={false}>
                        <div className={styles.footer}>
                            <Auth code="SF_GRglhO4j06">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={saveStatus.loading}>
                                    保存
                                </Button>
                            </Auth>
                        </div>
                    </Form.Item>
                </Form>
            </Spin>
        </div>
    );
}
